import React from "react";
import HOC from "../../../components/HOC";
import DetailAllocation from "../../../components/screen/centralWarehouse/allocation/DetailAllocation";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const DetailLocationPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Allocation Details"
        mainComponent={
          <ThemeProvider theme={theme}>
            <DetailAllocation type={1} />
          </ThemeProvider>
        }
        pageRole={34}
      />
    </div>
  );
};

export default HOC(DetailLocationPage);
